import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService'
import { GET_FLEET_ASSET_COMMENTS_HISTORY, GET_FLEET_ASSET_COMMENTS_SAVE } from '../../Store/FleetManagement/FleetAssetCommentsSave/FleetAssetCommentsSaveType'
import { setFleetCommentsHistory, setSaveFleetComments } from 'Store/FleetManagement/FleetAssetCommentsSave/FleetAssetCommentsSaveActions';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* SaveFleetCommentsSaga(req: any): any {
    try {
        yield put(globalLoaderText("Updating Fleet Request User Comments...."));
        let payloadData : IPayload = {
            apiType : apiType.FleetManagement,
            endpoint : `fleet/nonrequisition/comment`, 
            apiMethod :  apiMethod.POST,
            payload : req?.fleetCommentsSave
            
        }
        const response = yield call(
            FleetManagementApiService.post,API_URL.PostWebApp, payloadData
            
        );
        if (response) {
            yield put(setSaveFleetComments(response))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* getFleetCommentsHistory(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.FleetManagement,
            endpoint :  `fleet/nonrequisition/comment/history/orderRequestId?orderRequestId=${req?.orderId}`, 
            apiMethod :  apiMethod.GET,
            payload : null
            
        }
        yield put(globalLoaderText("Get Data...."));
        const response = yield call(
            FleetManagementApiService.post,API_URL.PostWebApp, payloadData
           
        );
        if (response) {
            yield put(setFleetCommentsHistory(response))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* watchGetFleetItemCancel() {
    yield takeEvery(GET_FLEET_ASSET_COMMENTS_SAVE, SaveFleetCommentsSaga)
    yield takeEvery(GET_FLEET_ASSET_COMMENTS_HISTORY, getFleetCommentsHistory)
}

export default function* combinedSaga() {
    yield all([
        watchGetFleetItemCancel()
    ])
}
